<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
  >
    <div class="bg-white rounded-lg shadow-lg p-2 w-[90%] max-w-4xl relative">
      <button
        class="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
        @click="closeModal"
      >
        &times;
      </button>
      <header v-if="title" class="mb-4 text-lg font-semibold">
        {{ title }}
      </header>
      <div class="modal-content">
        <slot></slot>
      </div>
      <footer v-if="$slots.footer" class="mt-4 flex justify-end">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalWindow",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-content {
  border: none;
  max-height: 70vh;
  overflow-y: auto;
}
</style>
